module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_m_albino.13dd76e6.png";